import {mapper} from 'ln/model/Mapper';
import {register} from 'ln/view/View';


// low-level helpers:
import Repeat from 'ln/components/Repeat';
import Resolve from './util/Resolve';
import Show from 'ln/components/Show';
import Trans from 'ln/components/Trans';
import Html from 'ln/components/Html';
import Placeholder from './util/Placeholder';
register('repeat', Repeat);
register('resolve', Resolve);
register('show', Show);
register('trans', Trans );
register('html', Html);
register('default', Placeholder);



// Chapter:
import {Chapter, chapterRegistrations} from './chapter';
mapper.toModel.add('App\\Chapter', (json: object) => new Chapter(json));
register(chapterRegistrations);


// Image:
import {ChapterImage, imageRegistrations} from './image';
mapper.toModel.add('App\\Image', (json: object ) => {
    json['asset'] = json['image'];
    delete json['image'];
    return new ChapterImage(json);
})
register(imageRegistrations);


// Module:
import {Module, moduleRegistrations} from './module';
mapper.toModel.add('App\\Module', (json: object) => new Module(json));
register(moduleRegistrations);


// Text:
import {Text, textRegistrations} from './text';
mapper.toModel.add('App\\Heading', (json: object) => new Text(json));
mapper.toModel.add('App\\Paragraph', (json: object) => new Text(json));
register(textRegistrations);


// Toggle:
import {SvgToggleView} from './toggle';
register('Toggle', () => new SvgToggleView('#checked', '#unchecked'));

// Video:
import {Video, videoRegistrations} from './video';
mapper.toModel.add( 'App\\Video', (json: object) => new Video(json));
register(videoRegistrations);

// StepBySTep:
import{StepByStep, StepTheme, stepbystepRegistrations} from './stepbystep';
mapper.toModel.add( 'App\\StepByStep', (json: object) => new StepByStep(json));
mapper.toModel.add( 'App\\StepTheme', (json: object) => new StepTheme(json));
register(stepbystepRegistrations);

// Quiz:
import{Quiz, QuizQuestion, quizRegistrations} from './quiz';
import{ ChoiceQuiz, Choice, ChoiceQuizType, TextChoice, TextChoiceInitialState, registrations as choiceQuizRegistrations} from 'ln/lernfragen/choice-quiz'
mapper.toModel.add( 'App\\Quiz', (json: object) => new Quiz(json));
mapper.toModel.add( 'App\\ChoiceQuestion', (json: { type:ChoiceQuizType, text:string, image:object, choices:Choice[]}) => {
    let question = new ChoiceQuiz({type:json.type, choices:json.choices});
    return new QuizQuestion({text:json.text, image:json.image, question:question});
});
mapper.toModel.add( 'App\\TextChoice', (json: TextChoiceInitialState) => new TextChoice(json) );
register(quizRegistrations);
register(choiceQuizRegistrations);


